import {createReducer} from 'redux-act';
import {Coordinates} from '@/common/interfaces/geolocation';
import {LocationPoint} from '@/common/interfaces/location';
import * as actions from './actions';

const initialState = {
	coordinates: null as Coordinates | null,
	exactSettlement: null as LocationPoint | null,
	generalSettlement: null as LocationPoint | null,
};

export const geolocationReducer = createReducer({}, initialState);

geolocationReducer
	.on(actions.determinateCoordinates.success, (state, coordinates) => ({
		...state,
		coordinates,
	}))
	.on(actions.determinateExactSettlement.success, (state, {location}) => ({
		...state,
		exactSettlement: location,
	}))
	.on(actions.determinateGeneralSettlement.success, (state, {location}) => ({
		...state,
		generalSettlement: location,
	}));
